import { graphql } from '@apollo/client/react/hoc'

import query from './query.graphql'

export { query }

export const mapDataToProps = ({ data: { userSettings } }) => ({
  ...userSettings,
  isListView: userSettings?.browseStoresView !== 'grid',
})

const withUserSettings = graphql(query, {
  props: mapDataToProps,
})

export default withUserSettings
